import { forgeLogout } from '../../../actions/forgeprovider.actions';
import { useDispatch } from 'react-redux';
import { useSiteConfig } from '../../SiteConfiguration';
import { useCache } from '../../../hooks/useCache';

export const useDispatchForgeLogout = () => {
	const { clearCache } = useCache();
	const dispatch = useDispatch();
	const { config } = useSiteConfig();
	return () => {
		clearCache();
		setTimeout(() => {
			dispatch(forgeLogout({ config }));
		}, 50);
	};
};

export default useDispatchForgeLogout;
